import Vue from "vue";
import { computed } from "@vue/composition-api";
import router from "@/router";

const data = Vue.observable({
  route: undefined,
});

router.afterEach((route) => {
  data.route = route;
});

export default function useRoute() {
  return computed(() => data.route);
}
